import Layout from "../../../../src/contents/sequenceDiagram/Layout";
import { Link } from 'gatsby';
import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  Layout,
  Link,
  SEO,
  React
};